import {CategoriesAPI} from "../api/CategoriesAPI";
import {AppStore} from "../desktop";
import {BaseService} from "./BaseService";
import {Folder} from "../models/Folder";
import {actionDeleteTabForItemId, actionSetTabItem, actionSetTabStateItem} from "../store/tabs/actions";
import {ErrorService} from "./ErrorService";
import {FoldersAPI} from "../api/FoldersAPI";
import {actionFolderFetchAllCompleted, actionFolderFetchCompleted, FoldersActionTypes} from "../store/folders";

export default class FoldersService extends BaseService {

	static getAll() {

        let foldersAPI: FoldersAPI = new FoldersAPI()

		foldersAPI.getAll().then(FoldersService.processResponse)
		.then((result) => actionFolderFetchAllCompleted(FoldersService.fromAPIList(result)))
		.catch(error => ErrorService.handleError(error))
	}

    static getOne(folder: Folder) {

		let foldersAPI: FoldersAPI = new FoldersAPI()

		foldersAPI.get(folder).then(FoldersService.processResponse).then(result => {
			actionFolderFetchCompleted(FoldersService.fromAPIItem(result))
        }).catch(error => ErrorService.handleError(error))

    }

    static save(folder: Folder) {

		let foldersAPI: FoldersAPI = new FoldersAPI()

		if (folder.id) {
			foldersAPI.put(FoldersService.itemToRequest(folder)).then(FoldersService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: FoldersActionTypes.SAVE_COMPLETED, payload: FoldersService.fromAPIItem(data)
					})
					actionSetTabStateItem(FoldersService.fromAPIToStateItem(data))
					actionSetTabItem(FoldersService.fromAPIItem(data))
				}
			).catch(error => ErrorService.handleError(error))
		} else {

			foldersAPI.post(FoldersService.itemToRequest(folder)).then(FoldersService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: FoldersActionTypes.SAVE_COMPLETED, payload: FoldersService.fromAPIItem(data)
					})
					actionSetTabStateItem(FoldersService.fromAPIToStateItem(data))
					actionSetTabItem(FoldersService.fromAPIItem(data))
				}
			).catch(error => ErrorService.handleError(error))

		}
	}

	static delete(folder: Folder) {

		let foldersAPI: FoldersAPI = new FoldersAPI()

		foldersAPI.delete(FoldersService.itemToRequest(folder)).then(FoldersService.processResponse).then(
			(data) => {
				AppStore.dispatch({
					type: FoldersActionTypes.DELETE_COMPLETED, payload: folder
				})
				actionDeleteTabForItemId(folder.id)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static deleteMultiple(folders: Folder[]) {

		let categoriesAPI: CategoriesAPI = new CategoriesAPI()
		let count = 0;
		folders.forEach(folder => {

			categoriesAPI.delete(FoldersService.itemToRequest(folder)).then(FoldersService.processResponse).then(
				(data) => {
					count++;
					actionDeleteTabForItemId(folder.id)
					if(count === folders.length)
						AppStore.dispatch({
							type: FoldersActionTypes.DELETE_MULTIPLE_COMPLETED, payload: folders
						})
				}
			).catch(error => ErrorService.handleError(error))
		});

	}

    static fromAPIList(apiList: any): Folder[] {
        const localList = apiList.map((apiItem: any) => FoldersService.fromAPIItem(apiItem));
        return localList;
    }

    static fromAPIItem(apiItem: any): Folder{
        let folder = new Folder();

		folder.id = apiItem.id;
		folder.parentId = apiItem.parentId
		folder.fields = JSON.parse(apiItem.fields);
		folder.title = apiItem.title
		folder.type = apiItem.type

        return folder;
    }

	static fromAPIToStateItem(apiItem: any): any{
		let folder = JSON.parse(apiItem.fields);
		return folder;
	}

    static itemToRequest (folder: Folder): any {

		let itemRequest: any = {}

		if(folder.id)
        	itemRequest.id = folder.id

		itemRequest.parentId = folder.parentId
		itemRequest.title = folder.title
		itemRequest.fields = folder.fields
		itemRequest.type = folder.type

		return itemRequest
	}

	static responseToItems (data: any) {
		return data
	}
}
